import BackTop from 'nsw-design-system/src/components/back-to-top/back-to-top.js';
import 'nsw-design-system/src/components/back-to-top/_back-to-top.scss';

export default async function decorate(block) {
  const buttonEle = document.createElement('button');
  buttonEle.className = 'nsw-button nsw-button--dark nsw-button--flex nsw-back-to-top js-back-to-top';
  block.append(buttonEle);
  const backTop = new BackTop(buttonEle);
  backTop.init();
}
